/**
 * @generated SignedSource<<6ae89cebd2a1ab3ddc5376eb113a8f76>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type UserAuthorizationLevel = "ADMIN" | "VISITOR" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type EventScreenJoin_query$data = {
  readonly viewer: {
    readonly authorizationLevel: UserAuthorizationLevel;
  } | null | undefined;
  readonly " $fragmentType": "EventScreenJoin_query";
};
export type EventScreenJoin_query$key = {
  readonly " $data"?: EventScreenJoin_query$data;
  readonly " $fragmentSpreads": FragmentRefs<"EventScreenJoin_query">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "EventScreenJoin_query",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "User",
      "kind": "LinkedField",
      "name": "viewer",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "authorizationLevel",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Query",
  "abstractKey": null
};

(node as any).hash = "295891ce670dd483b6c991af3608e960";

export default node;
